"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SearchBox = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _recompose = require("@hypnosphi/recompose");

var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));

var _ClickAwayListener = _interopRequireDefault(require("@mui/material/ClickAwayListener"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _ArrowDropDownSharp = _interopRequireDefault(require("@mui/icons-material/ArrowDropDownSharp"));

var _SearchSharp = _interopRequireDefault(require("@mui/icons-material/SearchSharp"));

var _withStyles = _interopRequireDefault(require("./withStyles"));

var _SearchFacets = _interopRequireDefault(require("./SearchFacets"));

var _enhancers = require("./enhancers");

var _SearchInput = _interopRequireDefault(require("./SearchInput"));

var _SearchDetails = _interopRequireDefault(require("./SearchDetails"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SearchClickAway = function SearchClickAway(_ref) {
  var onClickAway = _ref.onClickAway,
      children = _ref.children;
  var isMobile = (0, _useMediaQuery["default"])(function (theme) {
    return theme.breakpoints.down('lg');
  });

  if (isMobile) {
    return children;
  }

  return /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
    onClickAway: onClickAway
  }, children);
};

SearchClickAway.propTypes = {
  onClickAway: _propTypes["default"].func,
  children: _propTypes["default"].any
};

var SearchBox = function SearchBox(_ref2) {
  var classes = _ref2.classes,
      className = _ref2.className,
      autoFocus = _ref2.autoFocus,
      hideDetailsMenu = _ref2.hideDetailsMenu,
      handleKeyDown = _ref2.handleKeyDown,
      isDetailsMenuVisible = _ref2.isDetailsMenuVisible,
      toggleDetailsMenuVisibility = _ref2.toggleDetailsMenuVisibility,
      _ref2$facets = _ref2.facets,
      facets = _ref2$facets === void 0 ? [] : _ref2$facets,
      searchCriteria = _ref2.searchCriteria,
      setSearchCriteria = _ref2.setSearchCriteria,
      setSearchPhraseInternal = _ref2.setSearchPhraseInternal,
      makeHandleSearchInputChange = _ref2.makeHandleSearchInputChange,
      makeHandleClearSearchTerm = _ref2.makeHandleClearSearchTerm,
      makeHandleSearchInputSearch = _ref2.makeHandleSearchInputSearch,
      handleSearchInputFocus = _ref2.handleSearchInputFocus,
      dataQeId = _ref2.dataQeId,
      searchHintLabel = _ref2.searchHintLabel,
      searchDialogCloseLabel = _ref2.searchDialogCloseLabel,
      searchInputAriaLabel = _ref2.searchInputAriaLabel,
      searchIconAriaLabel = _ref2.searchIconAriaLabel,
      hideSearch = _ref2.hideSearch,
      searchPhrase = _ref2.searchPhrase,
      externalSearch = _ref2.externalSearch;
  return /*#__PURE__*/_react["default"].createElement(SearchClickAway, {
    onClickAway: hideDetailsMenu
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.root, className, _defineProperty({}, classes.rootActive, isDetailsMenuVisible))
  }, /*#__PURE__*/_react["default"].createElement(_SearchSharp["default"], {
    className: classes.searchIcon
  }), externalSearch, /*#__PURE__*/_react["default"].createElement(_SearchInput["default"], {
    classes: classes,
    dataQeId: dataQeId,
    ariaLabel: searchInputAriaLabel,
    autoFocus: autoFocus,
    facets: facets,
    setSearchPhraseInternal: setSearchPhraseInternal,
    makeHandleSearchInputChange: makeHandleSearchInputChange,
    makeHandleClearSearchTerm: makeHandleClearSearchTerm,
    searchHintLabel: searchHintLabel,
    hideSearch: hideSearch,
    searchPhrase: searchPhrase,
    handleSearchInputFocus: handleSearchInputFocus,
    makeHandleSearchInputSearch: makeHandleSearchInputSearch
  }), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "data-qe-id": "".concat(dataQeId, "_Load"),
    "aria-label": searchIconAriaLabel,
    className: (0, _classnames["default"])(classes.iconButton, classes.menuButton),
    onClick: toggleDetailsMenuVisibility,
    onKeyDown: handleKeyDown,
    size: "large"
  }, /*#__PURE__*/_react["default"].createElement(_ArrowDropDownSharp["default"], null)), isDetailsMenuVisible && /*#__PURE__*/_react["default"].createElement(_SearchDetails["default"], {
    classes: classes,
    isOpen: isDetailsMenuVisible,
    close: hideDetailsMenu,
    searchDialogCloseLabel: searchDialogCloseLabel
  }, /*#__PURE__*/_react["default"].createElement(_SearchFacets["default"], {
    qeIdTag: dataQeId,
    className: classes.searchFacets,
    searchCriteria: searchCriteria,
    setSearchCriteria: setSearchCriteria,
    facets: facets,
    hideDetailsMenu: hideDetailsMenu,
    hideSearch: hideSearch
  }))));
};

exports.SearchBox = SearchBox;
SearchBox.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  className: _propTypes["default"].string,
  autoFocus: _propTypes["default"].bool,
  facets: _propTypes["default"].array.isRequired,
  searchCriteria: _propTypes["default"].object.isRequired,
  setSearchCriteria: _propTypes["default"].func.isRequired,
  setSearchPhraseInternal: _propTypes["default"].func.isRequired,
  makeHandleSearchInputChange: _propTypes["default"].func.isRequired,
  hideDetailsMenu: _propTypes["default"].func,
  handleKeyDown: _propTypes["default"].func,
  isDetailsMenuVisible: _propTypes["default"].bool,
  toggleDetailsMenuVisibility: _propTypes["default"].func,
  makeHandleClearSearchTerm: _propTypes["default"].func,
  makeHandleSearchInputSearch: _propTypes["default"].func,
  handleSearchInputFocus: _propTypes["default"].func,
  dataQeId: _propTypes["default"].string,
  searchHintLabel: _propTypes["default"].string.isRequired,
  searchDialogCloseLabel: _propTypes["default"].string,
  searchInputAriaLabel: _propTypes["default"].string,
  searchIconAriaLabel: _propTypes["default"].string,
  hideSearch: _propTypes["default"].bool,
  searchPhrase: _propTypes["default"].string.isRequired,
  externalSearch: _propTypes["default"].node
};

var _default = (0, _recompose.compose)(_enhancers.withSearchState, _enhancers.withDetailsMenuHandler, _enhancers.withSearchInputHandler, _withStyles["default"], _enhancers.withSearchFacetProviders)(SearchBox);

exports["default"] = _default;